<template>
  <v-container fluid style="height: 100%" class="pa-0">
    <v-container fluid v-if="hasLoadingError" class="fill-height">
      <Error />
    </v-container>

    <v-container fluid v-else class="pa-0">
      <v-row justify="end">
        <!--<v-col
          cols="12"
          md="2"
          class="text-start"
          style="display: flex; align-items: center"
        >
          <span class="textLight&#45;&#45;text font-weight-medium text-h5">
            {{ $t("user.employees.employees") }}
          </span>
        </v-col>

        <v-spacer></v-spacer>-->

        <v-col v-if="havePermissionCreateEmployee" cols="12" sm="auto">
          <v-btn
            depressed
            min-height="45"
            block
            color="primary"
            style="text-transform: unset"
            class="rounded-lg font-weight-normal"
            @click="$refs.employeeList.createEmployee()"
          >
            <v-icon left> mdi-plus </v-icon>
            {{ $t("user.employees.addNewEmployee") }}
          </v-btn>
        </v-col>

        <v-col cols="12" sm="auto">
          <v-autocomplete
            :disabled="loading"
            hide-details
            v-model="organization"
            :items="organizations"
            item-value="_id"
            outlined
            dense
            background-color="white"
            :label="$t('user.registration.organization')"
            class="rounded-lg"
            clearable
            :filter="customLocalisedAutoCompleteFilter"
            style="max-width: 240px"
          >
            <template slot="selection" slot-scope="data">
              <span class="text-truncate" style="max-width: 170px">
                {{ getLocalisedValue(data.item.name) }}
              </span>
            </template>
            <template v-slot:item="{ item }">
              <div class="d-flex justify-start">
                {{ getLocalisedValue(item.name) }}
              </div>
            </template>
          </v-autocomplete>
        </v-col>

        <v-col cols="12" sm="auto">
          <v-autocomplete
            :disabled="loading"
            hide-details
            v-model="subRole"
            :items="subRoles"
            item-value="_id"
            outlined
            dense
            background-color="white"
            :label="$t('user.employees.assignedRoles')"
            class="rounded-lg"
            clearable
            :filter="customLocalisedAutoCompleteFilter"
            style="max-width: 200px"
          >
            <template slot="selection" slot-scope="data">
              <span class="text-truncate" style="max-width: 130px">
                {{ data.item.name }}
              </span>
            </template>
            <template v-slot:item="{ item }">
              <div class="d-flex justify-start">
                {{ item.name }}
              </div>
            </template>
          </v-autocomplete>
        </v-col>

        <v-col v-if="havePermissionCreateEmployee" cols="12" sm="auto">
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :disabled="loading"
                outlined
                block
                style="text-transform: unset"
                class="rounded-lg textLight--text font-weight-thin button"
                height="45"
                v-bind="attrs"
                v-on="on"
                :loading="importBtnLoading"
              >
                <v-icon>mdi-import</v-icon>
                {{ $t("reports.import") }}
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                v-for="(item, i) in importItems"
                :key="i"
                class="hand-cursor"
              >
                <v-list-item-title>
                  <FileSelector
                    v-if="item.value === 'xl'"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    @onFileSelect="onFileSelect"
                  >
                    <template v-slot:element="{ onClick }">
                      <div
                        class="d-flex align-center justify-space-between"
                        @click="onClick"
                      >
                        {{ item.text }}

                        <v-icon size="25" :color="item.iconColor" class="ms-2">
                          {{ item.icon }}
                        </v-icon>
                      </div>
                    </template>
                  </FileSelector>

                  <div
                    v-else
                    class="d-flex align-center justify-space-between"
                    @click="importFrom(item.value)"
                  >
                    {{ item.text }}

                    <v-icon size="25" :color="item.iconColor" class="ms-2">
                      {{ item.icon }}
                    </v-icon>
                  </div>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>

        <v-col cols="12" sm="auto">
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :disabled="loading"
                outlined
                block
                style="text-transform: unset"
                class="rounded-lg textLight--text font-weight-thin button"
                height="45"
                v-bind="attrs"
                v-on="on"
                :loading="exportBtnLoading"
              >
                <v-icon>mdi-export</v-icon>
                {{ $t("reports.export") }}
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                v-for="(item, i) in exportItems"
                :key="i"
                class="hand-cursor"
              >
                <v-list-item-title @click="exportTo(item.value)">
                  <div class="d-flex align-center justify-space-between">
                    {{ item.text }}
                    <v-icon size="25" :color="item.iconColor" class="ms-2">{{
                      item.icon
                    }}</v-icon>
                  </div>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>

        <v-col cols="12" sm="auto">
          <v-text-field
            v-model="search"
            hide-details
            prepend-inner-icon="mdi-magnify"
            color="textLight"
            clearable
            :placeholder="$t('course.search')"
            outlined
            dense
            background-color="white"
            class="shrink rounded-lg"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <employee-list
            :datas="employees"
            :organizations="organizations"
            :subRoles="subRoles"
            :loading="loading"
            @reRender="reRender"
            @responseErr="errResponse"
            ref="employeeList"
          />
        </v-col>

        <v-col cols="12" v-if="employees && employees.length">
          <Pagination :length="totalPages" @onPageSelect="onPagination" />
        </v-col>
      </v-row>
    </v-container>

    <v-snackbar v-model="snackbarSuccess" timeout="3000" color="success">
      {{
        snackbarSuccessMessage || $t("course.courseDetails.successfullySave")
      }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="snackbarSuccess = false"
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="snackbarError" timeout="3000" color="error">
      {{ snackbarErrorMessage || $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="snackbarError = false"
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Error from "@/app/core-module/components/Error";
import EmployeeList from "./EmployeeList.vue";
import Pagination from "../../core-module/components/Pagination.vue";
import FileSelector from "@/app/core-module/components/FileSelector";

import { hasPermission } from "@/app/user-module/helpers/authHelper";
import {
  excelExport,
  excelImport,
} from "../../reports-module/methods/excelExport";
import { importEmployees } from "@/app/user-module/methods/importEmployees";
import { doQuery } from "@/app/core-module/util/graphqlHelper";
import countries from "../../core-module/assets/json/countryList.json";

export default {
  name: "Employees",
  components: { FileSelector, Error, EmployeeList, Pagination },
  props: {
    defaultRole: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      hasLoadingError: false,
      search: null,
      organization: null,
      subRole: null,
      employees: [],
      organizations: [],
      subRoles: [],
      variables: {
        limit: 10,
        skip: 0,
      },
      totalCount: null,
      snackbarSuccess: false,
      snackbarError: false,
      snackbarSuccessMessage: null,
      snackbarErrorMessage: null,
      filterInput: {},
      importBtnLoading: false,
      exportBtnLoading: false,
      debounceSearch: null,
      importItems: [
        {
          value: "xl",
          text: this.$t("reports.importFrom"),
          icon: "mdi-microsoft-excel",
          iconColor: "success",
        },
        {
          value: "xl-sample",
          text: this.$t("reports.sampleExcel"),
          icon: "mdi-microsoft-excel",
          iconColor: "success",
        },
      ],
      exportItems: [
        {
          value: "xl",
          text: this.$t("reports.exportTo"),
          icon: "mdi-microsoft-excel",
          iconColor: "success",
        },
        // {
        //   value: "pdf",
        //   text: this.$t("reports.exportTo"),
        //   icon: "mdi-file-pdf-box",
        //   iconColor: "error",
        // },
      ],
      totalPages: 0,
    };
  },
  computed: {
    havePermissionCreateEmployee() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["CREATE_EMPLOYEE"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    isOrganizationManager() {
      return (
        this.$store.state.authenticatedUser?.isOrganizationManager ?? false
      );
    },
  },

  apollo: {
    getEmployees() {
      return {
        query: require("../api/query/getEmployees.gql"),
        variables: { ...this.variablesDefaultValue(), filterInput: null },
        result({ data, loading }) {
          if (data?.getEmployees) {
            this.employees = data.getEmployees.employees;
            this.totalCount = data.getEmployees.totalCount;
            let pagesVal = this.totalCount / this.variablesDefaultValue().limit;
            this.totalPages = this.checkNumberIsFloat(pagesVal)
              ? Math.ceil(pagesVal)
              : pagesVal;
          } else {
            this.hasLoadingError = true;
          }

          this.loading = loading;
        },
      };
    },
    getOrganizations() {
      return {
        query: require("../../organization-module/api/query/getOrganizations.gql"),
        variables: { limit: 0, skip: 0, filterInput: null },
        result({ data, loading }) {
          if (
            data &&
            data.getOrganizations &&
            data.getOrganizations.organizations
          ) {
            this.organizations = data.getOrganizations.organizations;
          }
        },
      };
    },
    getSubRoles() {
      return {
        query: require("../api/query/getSubRoles.gql"),
        variables: { limit: 0, skip: 0 },
        result({ data, loading }) {
          if (data && data.getSubRoles && data.getSubRoles.subRoles) {
            this.subRoles = data.getSubRoles.subRoles?.filter(
              x => x.isActive === true
            );
          }
        },
      };
    },
  },
  created() {
    this.refetch();
  },
  watch: {
    defaultRole: {
      immediate: false,
      async handler() {
        if (this.defaultRole) {
          await this.$apollo.queries.getSubRoles.refetch({
            limit: 0,
            skip: 0,
          });
          this.subRole = this.subRoles.find(
            x => x.name === this.defaultRole
          )?._id;
        }
      },
    },
    search() {
      clearTimeout(this.debounceSearch);
      this.debounceSearch = setTimeout(() => {
        this.apiSearch();
      }, 500);
    },
    subRole() {
      if (this.subRole) {
        this.filterInput.subRole = this.subRole;
      } else {
        delete this.filterInput?.subRole;
      }
      this.variables = this.variablesDefaultValue();
      this.refetch();
    },
    organization() {
      if (this.organization) {
        this.filterInput.organization = this.organization;
      } else {
        delete this.filterInput?.organization;
      }
      this.variables = this.variablesDefaultValue();
      this.refetch();
    },
  },
  methods: {
    checkNumberIsFloat(value) {
      return Number(value) === value && value % 1 !== 0;
    },
    findOrganization(id) {
      let val = this.organizations.find(obj => id === obj._id);
      if (val) {
        return this.getLocalisedValue(val.name);
      }
    },
    apiSearch() {
      const searchText = this.search?.trim() ?? "";

      if (searchText.length > 0) {
        this.variables = this.variablesDefaultValue();
        this.filterInput.search = searchText;
        this.refetch();
      } else if (searchText.length === 0 && this.filterInput?.search != null) {
        this.variables = this.variablesDefaultValue();
        delete this.filterInput?.search;
        this.refetch();
      }
    },
    async importFrom(value) {
      if (value === "xl-sample") {
        const employees = [
          {
            Name: "",
            Email: "",
            "Civil ID or Passport": "",
            Designation: "",
            Organization: "",
            "is Organization manager?": "TRUE",
            Roles: "",
            Gender: "Male",
            DOB: "23-12-1992",
            Mobile: "",
            "Blood group": "",
            Nationality: "KW",
            Department: "",
            Linkedin: "",
            Twitter: "",
            Facebook: "",
            Instagram: "",
            Coursera: "",
          },
        ];
        excelExport(employees, "sample-import-employees");
      }
    },
    async onFileSelect(file) {
      try {
        this.importBtnLoading = true;
        const jsonArray = await excelImport(file.blob);

        if (jsonArray?.length) {
          const organizations = await doQuery({
            query: require("../../organization-module/api/query/getOrganizations.gql"),
            variables: { limit: 0, skip: 0, filterInput: null },
          }).then(response => {
            if (response?.data?.getOrganizations?.organizations) {
              return response?.data?.getOrganizations?.organizations ?? [];
            }
          });

          const subRoles = await doQuery({
            query: require("../../user-module/api/query/getSubRoles.gql"),
            variables: { limit: 0, skip: 0 },
          }).then(response => {
            if (response?.data?.getSubRoles?.subRoles) {
              return response?.data?.getSubRoles?.subRoles ?? [];
            }
          });

          if (organizations?.length && subRoles?.length) {
            const employees = jsonArray.map(x => {
              const orgName = x["Organization"].trim();
              const orgId = organizations.find(
                o =>
                  orgName === o.UID ||
                  orgName ===
                    this.getLocalisedValue(o.name, {
                      preferredLocale: "en",
                    })?.trim()
              )?._id;

              if (!orgId) throw "Invalid organization!";

              const subRoleIds = x["Roles"]
                ?.split(",")
                ?.reduce((result, item) => {
                  const subRoleName = item?.trim();
                  const subRole = subRoles.find(
                    r => subRoleName === r.name?.trim()
                  );

                  if (subRole) result.push(subRole._id);
                  return result;
                }, []);

              let isOrganizationManager = false;
              try {
                const val = x["is Organization manager?"];

                if (val != null) {
                  if (typeof val === "boolean") {
                    isOrganizationManager = val;
                  } else {
                    isOrganizationManager = val?.toLowerCase() === "true";
                  }
                }
              } catch (_) {}

              let phone;
              try {
                const val = x["Mobile"];

                if (val) {
                  phone = {
                    countryCode: "+",
                    number: val.toString(),
                  };
                }
              } catch (_) {}

              let dob;
              try {
                const excelDateValue = x["DOB"];

                if (excelDateValue) {
                  dob = this.$moment
                    .utc("1899-12-30")
                    .add(excelDateValue, "days")
                    .format("YYYY-MM-DD");
                }
              } catch (_) {}

              let nationality;
              try {
                const countryCode = x["Nationality"];

                if (countryCode) {
                  nationality = countries.find(
                    c =>
                      countryCode === c.country_code || countryCode === c.name
                  )?.name;
                }
              } catch (_) {}

              return {
                user: {
                  firstName: x["Name"],
                  lastName: x["Last Name"],
                  civilIdOrPassport: x["Civil ID or Passport"],
                  email: x["Email"],
                  phone,
                  subRoles: subRoleIds,
                  isOrganizationManager,
                },
                organization: orgId,
                designation: x["Designation"],
                rigNumber: x["RIG number"],
                dob,
                gender: x["Gender"],
                externalLinks: {
                  linkedin: x["Linkedin"],
                  twitter: x["Twitter"],
                  facebook: x["Facebook"],
                  instagram: x["Instagram"],
                  coursera: x["Coursera"],
                },
                bloodGroup: x["Blood group"],
                nationality,
                department: x["Department"],
              };
            });

            importEmployees(employees).then(res => {
              if (res.error) this.$toast.error("Some error occurred!");
              this.importBtnLoading = false;
            });
          } else {
            this.importBtnLoading = false;
          }
        } else {
          this.$toast.error("Failed to read file!");
          this.importBtnLoading = false;
        }
      } catch (e) {
        this.$toast.error(e.message ?? "Some error occurred!");
        this.importBtnLoading = false;
      }
    },
    async exportTo(val) {
      if (val === "xl") {
        this.exportBtnLoading = true;
        let exportArr = await this.$apollo
          .query({
            query: require("../api/query/getEmployees.gql"),
            fetchPolicy: "no-cache",
            variables: {
              limit: 0, //1000,//export limit
              skip: 0,
              filterInput: this.filterInput ? this.filterInput : null,
            },
          })
          .then(result => {
            this.exportBtnLoading = false;
            if (result?.data?.getEmployees?.employees) {
              let employeesData = result.data.getEmployees.employees.map(
                employee => {
                  let obj = {};
                  obj[this.$t("user.registration.name")] = employee?.user
                    ?.firstName
                    ? `${employee.user.firstName || ""} ${
                        employee.user.lastName || ""
                      }`
                    : " - ";

                  obj[this.$t("user.email")] = employee?.user?.email
                    ? employee.user.email
                    : " - ";

                  obj[this.$t("user.civilIdOrPassport")] = employee?.user
                    ?.civilIdOrPassport
                    ? employee.user.civilIdOrPassport
                    : " - ";

                  obj[this.$t("user.registration.organization")] = employee
                    ?.organization?._id
                    ? this.findOrganization(employee.organization._id)
                    : "-";

                  let subRolesString = "";
                  if (employee?.user?.subRoles) {
                    let subRoles = this.findSubRoles(employee.user.subRoles);
                    subRolesString = this.getSubRolesString(subRoles);
                  } else subRolesString = " - ";
                  obj[this.$t("user.employees.roles")] = subRolesString;

                  return obj;
                }
              );

              return employeesData;
            }
          });
        let name = "employees";
        let fileName = name.concat("-", this.$moment().unix());
        excelExport(exportArr, fileName);
      }
    },
    findSubRoles(existingSubRolesArr) {
      let newArr = this.subRoles.filter(role => {
        return existingSubRolesArr.find(existingRole => {
          return role._id === existingRole._id;
        });
      });
      if (newArr.length) {
        return newArr.map(obj => {
          return obj.name;
        });
      }
    },
    getSubRolesString(arr) {
      if (arr?.length) {
        let stringVal = "";
        arr.forEach(role => {
          stringVal = stringVal.concat(role, ", ");
        });
        return stringVal;
      } else return " - ";
    },
    variablesDefaultValue() {
      return {
        limit: 10,
        skip: 0,
      };
    },
    onPagination(val) {
      if (val > 0) {
        this.variables.skip = this.variables.limit * (val - 1);
        this.refetch();
      }
    },
    errResponse(msg) {
      if (msg) this.snackbarErrorMessage = msg;
      this.snackbarError = true;
    },
    reRender() {
      this.variables = this.variablesDefaultValue();
      this.filterInput = {};
      this.search = null;
      this.organization = null;
      this.subRole = null;

      this.refetch();
    },
    async refetch() {
      this.loading = true;
      this.$apollo.queries.getEmployees.refetch({
        limit: this.variables.limit,
        skip: this.variables.skip,
        filterInput: this.filterInput ? this.filterInput : null,
      });
    },
  },
};
</script>
